// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "rec-" + chunkId + "." + {"73":"254d8d7b","286":"e29c603e","302":"0cf69c7e","353":"3d495485","525":"82b4a214","626":"2fc093e3","641":"b7b6b843","814":"f1897624","927":"c6835803"}[chunkId] + ".js";
};